'use strict';

var $d = require('../dependency');
var moment = $d.moment;
var _ = $d._;

exports.getLegendAdjustments = getLegendAdjustments;
exports.chartXaxisFormatter = chartXaxisFormatter;
exports.chartYaxisFormatter = chartYaxisFormatter;
exports.getXaxisOffset = getXaxisOffset;
exports.generateXaxisDaysData = generateXaxisDaysData;
exports.chartXaxisEllipsis = chartXaxisEllipsis;
exports.generateFieldKeysArray = generateFieldKeysArray;
exports.allEqualElemArray = allEqualElemArray;
exports.sformat = sformat;
exports.sum = sum;
exports.getUnitsFromMax = getUnitsFromMax;

function getLegendAdjustments(duration, compressLegend, extentWidthTo) {
    var y = 0,
        itemDistance = 12,
        width;

    if (compressLegend) {
        itemDistance = 6;
    }

    if (extentWidthTo) {
        width = extentWidthTo;
    }

    switch (duration) {
        case 'week':
            break;
        case 'month':
            break;
        case 'quarter':
            if (compressLegend) {
                y = 7;
            }
            break;
        case 'year':
            break;
        case 'thisMonth':
            break;
    }

    return {
        y: y,
        itemDistance: itemDistance,
        width: width
    };
}


function chartXaxisFormatter(xAxisValue, xMaxValue, baseUnit, roundOff) {
    return getUnits(xMaxValue, xAxisValue, baseUnit, roundOff);
}


function chartYaxisFormatter(yAxisValue, yMaxValue, baseUnit, roundOff, trimDecimalsPlaces) {
    var value;
    var valueObject = getUnits(yMaxValue, yAxisValue, baseUnit, roundOff, trimDecimalsPlaces);

    if (valueObject.unit && trimDecimalsPlaces) {
        valueObject.value = valueObject.value.toFixed(trimDecimalsPlaces);
    }

    return valueObject;
}

/**
 * This function is used to generate xaxis data for days based charts
 * !ToDo What is isNew?
 */
function generateXaxisDaysData(duration, granularity, value, isNew) {

    var dateValue,
        firstDate,
        secondDate,
        returnDateDisplay,
        timePeriod,
        durationToTimePeriodMap = {
            'P1M': 'month',
            'P1W': 'week',
            'day': 'day',
            'week': 'day',
            'month': 'day',
            'quarter': 'week',
            'year': 'month',
            'thisMonth': 'day'
        };

    if (!_.isString(value)) {
        dateValue = JSON.stringify(value);
    } else {
        dateValue = value;
    }
    //Handling for custom dates
    if (duration === 'custom') {
        timePeriod = durationToTimePeriodMap[granularity.period ? granularity.period : granularity];
    } else {
        timePeriod = durationToTimePeriodMap[duration];
    }

    if (moment(dateValue, 'DD/MM/YYYY').isValid) {
        switch (timePeriod) {
            case 'day':
                returnDateDisplay = moment.utc(dateValue).format('D MMM');
                break;
            case 'week':
                firstDate = moment(dateValue).format('D MMM');
                secondDate = moment(dateValue).add(6, 'days').format('D MMM');
                returnDateDisplay = firstDate + '-' + secondDate;
                break;
            case 'month':
                returnDateDisplay = moment(dateValue).format('MMM');
                break;
        }
    }

    return returnDateDisplay;
}

/**
 * [getXaxisOffsets find out how much to shift the Xaxis labels for various durations
 * because the date labels are variable for the different durations.]
 * @param  {string} duration [the duration]
 * @return {object}          [the X and Y coordinates to shift the x axis labels.]
 */
function getXaxisOffset(duration) {
    var x = -5,
        y = 35;
    switch (duration) {
        case 'week':
            break;
        case 'month':
            x = -7;
            y = 35;
            break;
        case 'quarter':
            x = -15;
            y = 35;
            break;
        case 'year':
            x = 0;
            y = 30;
            break;
        case 'thisMonth':
            break;
    }
    return {
        x: x,
        y: y
    };
}

/**
 * [chartXaxisEllipsis function to return ellipsed strings.]
 * @param  {Number} characterLimit [limit the characters to]
 * @param  {String} axisLabel      [the axis label to trim.]
 * @return {string}                [ellipsed text]
 */
function chartXaxisEllipsis(characterLimit, axisLabel) {

    var tempVal;

    if (characterLimit) {
        tempVal = axisLabel.slice(0, characterLimit);
    } else {
        tempVal = axisLabel;
    }

    return (axisLabel.length > tempVal.length) ? tempVal + '...' : tempVal;
};

/**
 * [generateFieldKeysArray function to generate keys which will be used as keys for the data series
 * which needs to be inputted to highcharts.]
 * @param  {array} queryParamsArray [the query param to generate druid queries.]
 * @return {array}                  [the keys for the highchart data series.]
 */
function generateFieldKeysArray(queryParamsArray, dataSeriesFields) {
    var returnFieldsArray = [];
    _.forEach(queryParamsArray, function(queryParams) {
        returnFieldsArray = _.union(returnFieldsArray, _.map(queryParams.aggregations, function(elem) {
            return elem.name;
        }));

        returnFieldsArray = _.union(returnFieldsArray, _.map(queryParams.postAggregations, function(elem) {
            return elem.name;
        }));

        /*!ToDo do not use strings.*/
        if (queryParams.queryType === 'timeseries') {
            returnFieldsArray.push('timestamp');

        } else if (queryParams.queryType === 'topN') {
            returnFieldsArray = _.union(returnFieldsArray, [queryParams.dimension]);

        } else if (queryParams.queryType === 'groupBy') {
            returnFieldsArray = _.union(returnFieldsArray, queryParams.dimensions);
        }
    });

    if (dataSeriesFields && dataSeriesFields.length) {
        returnFieldsArray = _.union(returnFieldsArray, dataSeriesFields);
    }

    return returnFieldsArray;
}

/**
 * [allNullArray returns true if all elements of the input array are null]
 * @param  {array} arrayData [the input array]
 * @return {Boolean}         [array all null or not]
 */
function allEqualElemArray(arrayData, elemMatcher) {
    return _.every(arrayData, function(elem) {
        if (elem === elemMatcher) {
            return true;
        }
    });
}

function sformat(format) {
    var args = Array.prototype.slice.call(arguments, 1);
    return format.replace(/{(\d+)}/g, function(match, number) {
        return typeof args[number] != 'undefined' ? args[number] : match;
    });
}

function sum(collection) {
    return _.reduce(collection, function(sum, n) {
        return sum + n;
    }, 0);
}

function getUnits(max, yValue, baseUnit, roundOff, trimDecimalsPlaces) {
    var yAxisUnit;
    var returnUnitValue = {};

    if (baseUnit === 'KB') {
        yAxisUnit = [{
            denomination: '(PB)',
            value: 1024 * 1024 * 1024 * 1024
        }, {
            denomination: '(TB)',
            value: 1024 * 1024 * 1024
        }, {
            denomination: '(GB)',
            value: 1024 * 1024
        }, {
            denomination: '(MB)',
            value: 1024
        }, {
            denomination: '(' + baseUnit + ')',
            value: 1
        }];
    } else {
        yAxisUnit = [{
            denomination: '(Trillions)',
            value: 1000000000000
        }, {
            denomination: '(Billions)',
            value: 1000000000
        }, {
            denomination: '(Millions)',
            value: 1000000
        }, {
            denomination: '(Thousands)',
            value: 1000
        }, {
            denomination: '',
            value: 1
        }];
    }

    _.forEach(yAxisUnit, function(object) {
        if (max >= object.value) {
            returnUnitValue.unit = object.denomination;
            returnUnitValue.value = (yValue / object.value);
            return false;
        } else {
            returnUnitValue.unit = '';
            returnUnitValue.value = yValue;
        }
    });

    if (roundOff) {
        if(trimDecimalsPlaces){
            returnUnitValue.value = Math.round(returnUnitValue.value * Math.pow(10, trimDecimalsPlaces))/Math.pow(10, trimDecimalsPlaces);    
        } else {
            returnUnitValue.value = Math.round(returnUnitValue.value);
        }
        
    }

    return returnUnitValue;
}

function getUnitsFromMax(max, units) {

    var yAxisUnit,
        returnObj = {};
    if (units === 'KB') {
        yAxisUnit = [{
            denomination: '(PB)',
            value: 1024 * 1024 * 1024 * 1024
        }, {
            denomination: '(TB)',
            value: 1024 * 1024 * 1024
        }, {
            denomination: '(GB)',
            value: 1024 * 1024
        }, {
            denomination: '(MB)',
            value: 1024
        }, {
            denomination: '(' + units + ')',
            value: 1
        }];
    } else {
        yAxisUnit = [{
            denomination: '(Trillions)',
            value: 1000000000000
        }, {
            denomination: '(Billions)',
            value: 1000000000
        }, {
            denomination: '(Millions)',
            value: 1000000
        }, {
            denomination: '(Thousands)',
            value: 1000
        }, {
            denomination: ' ',
            value: 1
        }];
    }

    _.forEach(yAxisUnit, function(object) {
        if (max >= object.value) {
            returnObj.unit = object.denomination;
            return false;
        } else {
            returnObj.unit = ' ';
        }
    });

    return returnObj;
}